@if (form; as form) {
  <div [formGroup]='form'>
    <fieldset>
      <legend>
        Decyzje
      </legend>
      <app-location-decisions-crud formControlName="locationDecisions">
      </app-location-decisions-crud>
    </fieldset>
    <fieldset>
      <legend>
        Etapy
      </legend>
      <app-tab-view
        [simple]='false'
        (onAddNew)='form.addStage()'
        addBtnTitle='Dodaj kolejny etap'
        [showAddButton]='true'
        [centered]='true'
        formArrayName="stages">
        @for (stageForm of form.getStageForms(); track $index) {
          <app-tab-panel
            (onClose)='form.removeStage($index)'
            [closeBtnDisabled]='$index === 0'
            [showCloseBtn]='true'
            [name]='"Etap nr " + ($index + 1)'
            [selected]='$index === (form.stages.controls.length - 1)'>
            <app-ad-placement-stage-form
              [form]="stageForm"
              [label]='"Etap nr " + ($index + 1)'>
            </app-ad-placement-stage-form>
          </app-tab-panel>
        }
      </app-tab-view>
    </fieldset>
  </div>
}
